/**
 * @fileoverview POST handler for the "/engagement/report_dashboards/:app_group_id/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardsAppGroupIdUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementReportDashboardsAppGroupIdUpdateArchivedStateProps,
  EngagementReportDashboardsAppGroupIdUpdateArchivedStateResult,
} from "./types";

export const postEngagementReportDashboardsAppGroupIdUpdateArchivedState = reactQueryMutationAdapter(
  engagementReportDashboardsAppGroupIdUpdateArchivedStateCacheKeys,
  (
    props: PostEngagementReportDashboardsAppGroupIdUpdateArchivedStateProps
  ): Promise<EngagementReportDashboardsAppGroupIdUpdateArchivedStateResult> => {
    return fetch(
      `/engagement/report_dashboards/${props.appGroupId}/update_archived_state`,
      "POST",
      {
        dashboard_ids: props.dashboardIds,
        operation: props.operation,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
